/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext, useRef } from "react"; //import the component part of React
import withRouter from "../WithRouter";
import { Navigate } from "react-router-dom";
import { isAuthenticatedCustomer } from "./services/CustomerAuth";
// Common
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Col, Row, Container, Form } from "react-bootstrap";
//Subcomponents
import BlockInfo from "./page-parts/BlockInfo";
import BlockCheckoutForm from "./page-parts/BlockCheckoutForm";
import StripeWrapper from "../common/StripeWrapper";
//Loading
import LoadingSpinner from "../LoadingSpinner";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Analytics
import TagManager from "react-gtm-module";

const BlockCheckout = (props) => {
  // State
  const [blockData, setBlockData] = useState("");
  const [displayPrice, setDisplayPrice] = useState("");
  const [selectedParticipant, setSelectedParticipant] = useState("");
  // Get the classID and context.
  const blockid = props.params.blockid;
  const BusinessContext = useContext(BusinessContextConsumer);
  const { businessID, currencySymbol, currency } = BusinessContext;
  // ref the block ID
  const prevBlockId = useRef(); //Reference the previous block ID to ensure new get request if it changes.
  // Get the class proration data if needed
  useEffect(async () => {
    prevBlockId.current = blockid; // Assign Refs Value to current load
    let priceToDisplay;
    // Request the Class Data
    const BlockDataRequest = await axios.get(
      `/api/public_view/block_selected/${businessID}/${blockid}`,
      {
        withCredentials: true,
      }
    );

    if (BlockDataRequest.data.Prorate) {
      const prorationPriceRequest = await axios.get(
        `/api/public_view/block_selected/prorate/${businessID}/${blockid}`,
        {
          withCredentials: true,
        }
      );
      priceToDisplay = prorationPriceRequest.data.prorationPrice;
    } else {
      priceToDisplay = BlockDataRequest.data.Price;
    }

    //Set the Datalayer Event
    TagManager.dataLayer({
      dataLayer: {
        event: "loggedInClassView",
        lessonType: BlockDataRequest.data.LessonType,
      },
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "view_item",
        ecommerce: {
          items: [
            {
              item_name: BlockDataRequest.data.LessonType,
              price: BlockDataRequest.data.Price,
              item_category: "block",
              quantity: 1,
            },
          ],
        },
      },
    });

    setSelectedParticipant(""); // Reloaded page so clear the selected Participant.
    setDisplayPrice(priceToDisplay);
    return setBlockData(BlockDataRequest.data);
  }, [blockid]); // Run useEffect when the classID changes to get new class data.

  // Remove the interested block if there was one.
  if (sessionStorage.getItem("interestedBlock") !== null) {
    sessionStorage.removeItem("interestedBlock");
  }

  if (blockData) {
    return (
      <FadeIn delay={250} duration={450}>
        <Container>
          {!isAuthenticatedCustomer() && <Navigate to='/login/' />}
          <BlockInfo
            displayPrice={displayPrice}
            blockData={blockData}
            currencySymbol={currencySymbol}
          />
            <BlockSubscribersSelector
              blockData={blockData}
              displayPrice={displayPrice}
              setSelectedParticipant={setSelectedParticipant}
              currencySymbol={currencySymbol}
            />
          {selectedParticipant !== "" && (
            <>
              <StripeWrapper>
                <BlockCheckoutForm
                  blockData={blockData}
                  selectedParticipant={selectedParticipant}
                  currency={currency}
                  endpoint='general'
                  displayPrice={displayPrice}
                />
              </StripeWrapper>
            </>
          )}
        </Container>
      </FadeIn>
    );
  } else {
    return <LoadingSpinner />;
  }
};

const BlockSubscribersSelector = (props) => {
  const [eligibleParticipants, setEligibleParticipants] = useState([]);
  const blockid = props.blockData._id;
  const prevBlockId = useRef();
  useEffect(async () => {
    prevBlockId.current = blockid;
    const getEligibleParticipants = await axios.get(
      `/api/customer/customer_general/eligible_for_block/${blockid}`,
      {
        withCredentials: true,
      }
    );
    return setEligibleParticipants(getEligibleParticipants.data);
  }, [blockid]);

  if (eligibleParticipants.length > 0) {
    return (
      <FadeIn delay={250} duration={450}>
        <Row>
          <Col sm='12'>
            <Form className='shadow mt-4 p-3 border'>
              <h3 className='mt-2 mb-2'>Book</h3>
              <Form.Label>Choose your participant</Form.Label>
              <Form.Control
                as='select'
                value={props.selectedParticipant}
                onChange={(e) => props.setSelectedParticipant(e.target.value)}
                required
                custom
                className='border'
              >
                <option value='' defaultValue>
                  Select your option
                </option>
                {eligibleParticipants.map((Participant) => (
                  <option key={Participant._id} value={Participant._id}>
                    {Participant.First_Name + " " + Participant.Last_Name}
                  </option>
                ))}
              </Form.Control>
              <Form.Text className='text-muted mt-2 mb-2'>
                The participant is the person you are booking on the class. It might be you, a
                child, or someone else you are responsible for. If you do not have a participant
                yet, you should set them up on your dashboard.{" "}
                <strong>
                  By entering your card details and clicking &quot;book&quot; you will create a
                  single charge with stripe of{" "}
                  {props.currencySymbol + parseFloat(props.displayPrice).toFixed(2)} as outlined in our terms and conditions.
                </strong>
              </Form.Text>
            </Form>
          </Col>
        </Row>
      </FadeIn>
    );
  } else {
    return (
      <Row>
        <Col sm='12' className='shadow mt-4 p-3 border text-center'>
          <div>
            <h3>No eligible participants...</h3>
          </div>
        </Col>
      </Row>
    );
  }
};

//Export
export default withRouter(BlockCheckout);
